export const downloadBlobFile = (blob: Blob, fileName: string): void => {
  // Cria uma URL temporária para o Blob
  const url = window.URL.createObjectURL(blob);

  // Cria um link <a> para simular o download
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName; // Define o nome do arquivo para o download

  // Adiciona o link ao DOM e dispara o clique
  document.body.appendChild(link);
  link.click();

  // Remove o link e revoga a URL temporária
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const sanitizeReportFilenameBase = (value: string) => {
  const normalized = (value ?? '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

  const onlyLettersNumbersAndSpaces = normalized.replace(/[^a-zA-Z0-9 ]+/g, '');
  const trimmed = onlyLettersNumbersAndSpaces.trim();
  const withUnderscores = trimmed.replace(/\s+/g, '_');
  const collapsed = withUnderscores.replace(/_+/g, '_');

  return collapsed || 'report';
};

export const buildSafeReportFilenameFromDescription = (
  description: string,
  extension?: string,
  maxLength = 60,
): string => {
  const ext = extension
    ? extension.startsWith('.')
      ? extension
      : `.${extension}`
    : '';

  const safeMaxLength = Number.isFinite(maxLength) ? Math.max(1, maxLength) : 60;
  const maxBaseLength = Math.max(1, safeMaxLength - ext.length);

  const base = sanitizeReportFilenameBase(description).slice(0, maxBaseLength).replace(/_+$/g, '');
  const finalBase = base || 'report';

  return `${finalBase}${ext}`;
};

